import React, { useEffect, useState } from "react";
import { MONTHS, YEARS, api } from "../lib/api";
import { RefreshCw, RotateCcw } from "lucide-react";

export default function Filters({
  value, onChange, showRw = false, showRt = false, onRefresh, defaultsCurrent = true
}) {
  const [rwList, setRwList] = useState([]);
  const [rtList, setRtList] = useState([]);

  useEffect(() => {
    api.regions().then((r) => setRwList(r.rw_list || [])).catch(() => setRwList([]));
  }, []);

  useEffect(() => {
    if (showRt && value.rw) {
      api.listRt(value.rw).then((r) => setRtList(r.data || [])).catch(() => setRtList([]));
    } else {
      setRtList([]);
    }
  }, [showRt, value.rw]);

  const reset = () => {
    const now = new Date();
    const bulan = MONTHS[now.getMonth()].value;
    onChange({ tahun: String(now.getFullYear()), bulan, rw: "", rt: "" });
  };

  const cls = "w-full h-11 px-3 rounded-lg border border-[hsl(var(--border))] bg-white text-sm font-medium text-[#0e2b26] focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))] focus:border-transparent transition";

  return (
    <div className="bg-white rounded-xl border border-[hsl(var(--border))] p-4 sm:p-5 no-print">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        <div>
          <label className="block text-[0.7rem] font-bold tracking-wider text-[hsl(var(--muted-foreground))] uppercase mb-1.5">Tahun</label>
          <select className={cls} value={value.tahun} onChange={(e) => onChange({ ...value, tahun: e.target.value })} data-testid="filter-tahun">
            {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-[0.7rem] font-bold tracking-wider text-[hsl(var(--muted-foreground))] uppercase mb-1.5">Bulan</label>
          <select className={cls} value={value.bulan} onChange={(e) => onChange({ ...value, bulan: e.target.value })} data-testid="filter-bulan">
            {MONTHS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
        </div>
        {showRw && (
          <div>
            <label className="block text-[0.7rem] font-bold tracking-wider text-[hsl(var(--muted-foreground))] uppercase mb-1.5">RW</label>
            <select className={cls} value={value.rw || ""} onChange={(e) => onChange({ ...value, rw: e.target.value, rt: "" })} data-testid="filter-rw">
              <option value="">Semua RW</option>
              {rwList.map((r) => <option key={r.rw} value={r.rw}>RW {r.rw}</option>)}
            </select>
          </div>
        )}
        {showRt && (
          <div>
            <label className="block text-[0.7rem] font-bold tracking-wider text-[hsl(var(--muted-foreground))] uppercase mb-1.5">RT</label>
            <select className={cls} value={value.rt || ""} onChange={(e) => onChange({ ...value, rt: e.target.value })} disabled={!value.rw} data-testid="filter-rt">
              <option value="">Semua RT</option>
              {rtList.map((r) => <option key={r.rt} value={r.rt}>RT {r.rt}</option>)}
            </select>
          </div>
        )}
        <div className="col-span-2 sm:col-span-1 flex items-end gap-2">
          <button onClick={reset} className="flex-1 h-11 px-3 rounded-lg border border-[hsl(var(--border))] bg-white text-sm font-semibold text-[#0e2b26] hover:bg-[hsl(var(--muted))] flex items-center justify-center gap-2 transition" data-testid="filter-reset">
            <RotateCcw size={15} /> Reset
          </button>
        </div>
        <div className="col-span-2 sm:col-span-1 flex items-end">
          <button onClick={onRefresh} className="w-full h-11 px-3 rounded-lg bg-[#0e2b26] text-white text-sm font-semibold hover:bg-[#123832] flex items-center justify-center gap-2 transition" data-testid="filter-refresh">
            <RefreshCw size={15} /> Segarkan
          </button>
        </div>
      </div>
    </div>
  );
}
